import React from 'react';

interface Props {
    body?: React.ReactNode;
}

export default function EmptyState({ body }: Props) {
    return (
        <div className="w-full text-center">
            <img src="/images/empty-state.svg" alt="There is no content available" className="w-1/2 py-8 m-auto" />
            {body}
        </div>
    );
}
